import { gql } from 'urql'

export const queryFeatureConfigs = gql`
  query ($featuresConfigCondition: feature_config_bool_exp, $offset: Int!, $limit: Int!) {
    feature_config(
      where: $featuresConfigCondition
      offset: $offset
      limit: $limit
      order_by: [{ feature_config_name_locale: asc }, { id: asc }]
    ) {
      id
      feature_config_name_locale
      processes
      active
      feature_type_config {
        names
      }
      feature_group_config {
        names
      }
      feature_deletability {
        is_deletable
      }
    }
    feature_config_aggregate(where: $featuresConfigCondition) {
      aggregate {
        count
      }
    }
  }
`

export const queryFeatureConfigById = gql`
  query ($featureConfigId: Int!) {
    feature_config(where: { id: { _eq: $featureConfigId } }) {
      id
      names
      tooltips
      processes
      levels
      has_kpi_for_processes
      has_kpi_for_levels
      selection_type
      active
      feature_type_id
      feature_group_id
    }
  }
`

export const queryHighestFeatureConfigSortNumber = gql`
  query {
    feature_config_aggregate {
      aggregate {
        max {
          sort_number
        }
      }
    }
  }
`

export const insertFeatureConfig = gql`
  mutation ($featureConfigInsertInput: [feature_config_insert_input!]!) {
    insert_feature_config(objects: $featureConfigInsertInput) {
      affected_rows
    }
  }
`

export const updateFeatureConfigById = gql`
  mutation ($featureConfigId: Int!, $featureConfigSetInput: feature_config_set_input!) {
    update_feature_config(where: { id: { _eq: $featureConfigId } }, _set: $featureConfigSetInput) {
      affected_rows
    }
  }
`

export const deleteFeatureConfigById = gql`
  mutation ($featureConfigId: Int!) {
    delete_feature_config(where: { id: { _eq: $featureConfigId } }) {
      affected_rows
    }
  }
`
